export const getPaymentMethodFromNotes = (notes: string = ""): string => {
  console.log("Analyzing notes:", notes);
  
  if (!notes) {
    console.log("Notes empty, using default");
    return "Autres mode de paiement";
  }

  if (notes.toLowerCase().includes("espèces") || 
      notes.toLowerCase().includes("especes") ||
      notes.toLowerCase().includes("cash")) {
    console.log("Transaction Espèces détectée");
    return "Espèces";
  }

  if (notes.toLowerCase().includes("wave")) {
    console.log("Transaction Wave détectée");
    return "Wave";
  }

  if (notes.toLowerCase().includes("orange money")) {
    console.log("Transaction Orange Money détectée");
    return "Orange Money";
  }

  if (notes.toLowerCase().includes("carte")) {
    console.log("Transaction Carte bancaire détectée");
    return "Carte bancaire";
  }

  if (notes.toLowerCase().includes("mobile money")) {
    console.log("Transaction Mobile Money détectée");
    return "Mobile Money";
  }

  if (notes.toLowerCase().includes("bank_transfer") ||
      notes.toLowerCase().includes("virement")) {
    console.log("Transaction Virement bancaire détectée");
    return "Virement bancaire";
  }

  if (notes.toLowerCase().includes("vente à crédit")) {
    console.log("Transaction Vente à crédit détectée");
    return "Vente à crédit";
  }

  // Si aucune correspondance n'est trouvée, retourner "Autres mode de paiement"
  console.log("Aucun mode de paiement spécifique détecté, utilisation de 'Autres mode de paiement'");
  return "Autres mode de paiement";
};

export const getDefaultPaymentMethod = (method?: string): string => {
  if (!method) return "Autres mode de paiement";
  
  const normalizedMethod = method.toLowerCase();
  
  if (normalizedMethod.includes("espèces") || 
      normalizedMethod.includes("especes") ||
      normalizedMethod.includes("cash")) {
    return "Espèces";
  }
  if (normalizedMethod.includes("wave")) return "Wave";
  if (normalizedMethod.includes("orange money")) return "Orange Money";
  if (normalizedMethod.includes("carte")) return "Carte bancaire";
  if (normalizedMethod.includes("mobile money")) return "Mobile Money";
  if (normalizedMethod.includes("bank_transfer") ||
      normalizedMethod.includes("virement")) return "Virement bancaire";
  if (normalizedMethod.includes("vente à crédit")) return "Vente à crédit";
  
  return "Autres mode de paiement";
};